import { useFormikContext } from "formik";
import { Switch } from "src/sudokit/components/Switch";
import { BLOCK_TYPES } from "../../../../../../../src/shared/schemas/PluginSchema";
import { generateId } from "../../../../../../../src/shared/schemas/CharacterSchema";
import BlockEditor from "./BlockEditor";

const closeRequestBlock = () => {
  return { id: generateId(), blockType: BLOCK_TYPES.CLOSE_REQUEST, options: {} };
};

const cardOutputBlock = () => {
  return { id: generateId(), blockType: BLOCK_TYPES.CARD_OUTPUT, options: {} };
};

const outputBlockTypes = [BLOCK_TYPES.CARD_OUTPUT, BLOCK_TYPES.CLOSE_REQUEST];
function OutputEditor({ outputBlocks }) {
  const { values, setFieldValue } = useFormikContext();
  const isCardOutput = outputBlocks.some((b) => b.blockType === BLOCK_TYPES.CARD_OUTPUT);

  const switchOutputType = () => {
    const oldOutputRemoved = values.blocks.filter((b) => !outputBlockTypes.includes(b.blockType));
    const newBlocks = [...oldOutputRemoved, isCardOutput ? closeRequestBlock() : cardOutputBlock()];
    setFieldValue("blocks", newBlocks);
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <span>Output type:</span>
        <span>End Request</span>
        <Switch
          variant="tertiary"
          checked={isCardOutput}
          onCheckedChange={switchOutputType}
        />
        <span>Card</span>
      </div>
      {isCardOutput &&
        outputBlocks.map((block, index) => (
          <BlockEditor
            key={block.id}
            block={block}
            index={index}
          />
        ))}
    </div>
  );
}

export default OutputEditor;
